var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[(_vm.product != null)?_c('div',[(_vm.liveproductObjHtml != null)?_c('div',{directives:[{name:"lazy-load",rawName:"v-lazy-load",value:(_vm.liveproductObjHtml),expression:"liveproductObjHtml"}],staticClass:"ps-document"}):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }